import React from 'react';
import SearchUsersScreen from './SearchUsersScreen';
export default {
  id: 'recovr.users.searchUsers',
  matches: {
    client: 'Main'
  },
  exact: true,
  path: '/searchUsers/',
  default: false,
  render: ctx => /*#__PURE__*/React.createElement(SearchUsersScreen, ctx)
};